"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dialog = _interopRequireWildcard(require("@ux/dialog"));
var _legacy = require("./legacy");
const _excluded = ["children", "emphasis", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UX_ALERT_CLASSNAME = 'ux-alert';
function Alert(_ref) {
  let {
      children,
      emphasis,
      className
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_dialog.default, (0, _extends2.default)({
    role: "alert",
    contrast: true,
    emphasis: emphasis,
    className: (0, _classnames.default)(UX_ALERT_CLASSNAME, className, {
      [`${UX_ALERT_CLASSNAME}--${emphasis}`]: emphasis && _dialog.default.ACCESSORIES[emphasis]
    }),
    "data-version": "2400.9",
    space: {
      inline: _dialog.spaceOptions.MD,
      block: _dialog.spaceOptions.MD
    },
    stretch: true
  }, (0, _legacy.transform)(rest)), children);
}
Alert.propTypes = {
  /** Adds actions */
  actions: _propTypes.default.node,
  /** Screenreader labels for sub-elements */
  ariaLabels: _propTypes.default.shape({
    /** Screen reader label for close button */
    close: _propTypes.default.string
  }),
  /** Provides a contrast overlay to the component */
  contrast: _propTypes.default.bool,
  /** Class name applied to component */
  className: _propTypes.default.string,
  /** Additional detail content */
  children: _propTypes.default.node,
  /** Describes the importance of the message */
  emphasis: _propTypes.default.oneOf(Object.keys(_dialog.default.ACCESSORIES)),
  /** Adds icon to the title */
  icon: _propTypes.default.node,
  /** Assigns title to component for a11y */
  id: _propTypes.default.string,
  /** Callback function when component is closed */
  onClose: _propTypes.default.func,
  /** Card space configuration */
  space: _propTypes.default.object,
  /** Stretches full width of container */
  stretch: _propTypes.default.bool,
  /** Adds title with @ux/text */
  title: _propTypes.default.node
};
var _default = exports.default = Alert;